import {FlowFreeSpinsState} from '@fantasmagames/slot/src/modules/flow/states/FlowFreeSpinsState';
import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {EventsFlowPairs} from '@fantasmagames/slot/src/modules/flow/states/QueueEventsHandler';
import {GameFlowEvents} from 'src/flow/GameFlowEvents';
import {GameAvalancheReelsEvents} from 'src/avalanche/GameAvalancheReelsEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {FreeSpinsTriggerModule} from 'src/freespinstrigger/FreeSpinsTriggerModule';

export class GameFlowFreeSpinsState extends FlowFreeSpinsState {

	protected hasAnyBeforeWinFeatures(): boolean {
		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);

		return logic.hasWinsToHighlight();
	}

	protected addBeforeWinFeatures(): void {
		super.addBeforeWinFeatures();

		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);
		const eventsPairs: EventsFlowPairs[] = [];

		if (logic.hasWinsToHighlight()) {
			eventsPairs.push({
				start: GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT,
				end: GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED,
			});
		}

		if (eventsPairs.length > 0) {
			this._queueEvents.addEventsPairFlow(eventsPairs, this.decideOnNextAction.bind(this));
		} else {
			throw new Error(`GameFlowFreeSpinsState::addBeforeWinFeatures need more events`);
		}
	}

	protected setupNextStateAvalancheFlow(): void {
		this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents.AVALANCHE_WON, () => {
			this.module.gotoState(FlowModule.AVALANCHE_STATE);
		});

		this.emit(FlowModuleEvents.AVALANCHE_WON);
	}

	protected setupBigWinNoWinAfterwards(): void {
		this.emit(FlowModuleEvents.WON_BIG_WIN);
	}

	protected setupWin(): void {
		this.emit(FlowModuleEvents.WON);
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		if (logic.hasFreeSpinsRetrigger) {
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
			this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
			this._queueEvents.addEventToWaitingList(FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents.CAN_SPIN);
		} else {
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.CAN_SPIN);
		}

	}

	protected setupBigWin(): void {
		this._queueEvents.addEventToWaitingList(BigWinEvents.FINISHED, FlowModuleEvents.WON);
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		if (logic.hasFreeSpinsRetrigger) {
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
			this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
			this._queueEvents.addEventToWaitingList(FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents.CAN_SPIN);
		} else {
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.CAN_SPIN);
		}
		this.emit(FlowModuleEvents.WON_BIG_WIN);
	}

	protected setupNoWin(): void {
		this.emit(FlowModuleEvents.NO_WIN);
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		if (logic.hasFreeSpinsRetrigger) {
			this.emit(GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
			this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
			this._queueEvents.addEventToWaitingList(FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents.CAN_SPIN);
		} else {
			this.sendOutCanSpin();
		}
	}
}



// WEBPACK FOOTER //
// ./src/flow/states/GameFlowFreeSpinsState.ts